export class TermModel {
  public id?: string = '';
  public file?: string = '';
  public fileUrl?: string = '';
  public platform: string = '';
  public version: string = '';
}
